export default function isEmpty(value: string): boolean {
  return value.trim() === "";
}
